import { render } from "./DataflowView.vue?vue&type=template&id=019fadad&scoped=true"
import script from "./DataflowView.vue?vue&type=script&lang=js"
export * from "./DataflowView.vue?vue&type=script&lang=js"

import "./DataflowView.vue?vue&type=style&index=0&id=019fadad&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-019fadad"

export default script